import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { IonLoading } from '@ionic/react';

interface IRequireAuthProps {
  children?: React.ReactElement;
}

export const RequireAuth: React.FC<IRequireAuthProps> = (
  props: IRequireAuthProps,
) => {
  const { isAuthenticated, isLoading } = useAuth0();
  if (isLoading)
    return (
      <IonLoading isOpen={true} message={'Please wait...'} duration={5000} />
    );

  if (!isAuthenticated)
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { redirectUrl: window.location.pathname },
        }}
      />
    );

  return props.children || null;
};
